// GF1 (Dokumanlar/Arayuz/GOMULU-FORM-TEMA-PLANI.md §10 R1): localStorage sarmalayıcısı.
// Üçüncü taraf iframe'de (Chrome "3. taraf çerezleri engelle", Safari ITP) window.localStorage
// erişimi SecurityError fırlatabilir; uygulama boot'ta çökmesin diye tüm okuma/yazma try/catch'li.
// Erişim yoksa bellek içi yedek kullanılır (sayfa ömrü boyunca) — normal tarayıcıda davranış aynı.

const bellek = {};

// OT-6 (Dokumanlar/Guvenlik/COKLU-OTURUM-PLANI.md §3.7): "Şirkete geç" anahtarı yalnız o sekmede
// (sessionStorage impToken). Varken token/tokenExpiration oradan okunur ve yazılır, refreshToken yok
// sayılır (sağlayıcının anahtarıyla sessiz yenileme olmasın), oturum anahtarlarını silmek yalnız
// sekme anahtarını siler — sağlayıcının öbür sekmeleri ortak depodaki oturumunda kalır.
// Kip işareti impSekme: anahtar silinse de (401) sekme ortak depoya dönmez; "Konsola dön" ya da yeni
// giriş (auth.service sirketeGecTemizle) kaldırır.
const SEKME = { token: 'impToken', tokenExpiration: 'impTokenExpiration' };
const SEKMEDE_KORUNAN = ['refreshToken', 'user'];

function sekmeDeposu() {
  try { return window.sessionStorage || null; } catch (e) { return null; }
}

export function sirketeGecSekmesi() {
  const s = sekmeDeposu();
  try { return !!(s && s.getItem('impSekme')); } catch (e) { return false; }
}

function depoAl() {
  try {
    const d = window.localStorage;
    return d || null;
  } catch (e) {
    return null;
  }
}

export function oku(anahtar) {
  if (sirketeGecSekmesi()) {
    if (SEKME[anahtar]) return sekmeDeposu().getItem(SEKME[anahtar]);
    if (anahtar === 'refreshToken') return null;
  }
  const d = depoAl();
  if (d) {
    try { return d.getItem(anahtar); } catch (e) { /* yedeğe düş */ }
  }
  return Object.prototype.hasOwnProperty.call(bellek, anahtar) ? bellek[anahtar] : null;
}

export function yaz(anahtar, deger) {
  if (SEKME[anahtar] && sirketeGecSekmesi()) {
    try { sekmeDeposu().setItem(SEKME[anahtar], deger); return; } catch (e) { /* ortak depoya düş */ }
  }
  const d = depoAl();
  if (d) {
    try { d.setItem(anahtar, deger); return; } catch (e) { /* yedeğe düş */ }
  }
  bellek[anahtar] = String(deger);
}

export function sil(anahtar) {
  if (sirketeGecSekmesi() && (SEKME[anahtar] || SEKMEDE_KORUNAN.includes(anahtar))) {
    if (anahtar === 'token') {
      try { ['impToken', 'impTokenExpiration'].forEach((k) => sekmeDeposu().removeItem(k)); } catch (e) { /* yoksay */ }
    } else if (SEKME[anahtar]) {
      try { sekmeDeposu().removeItem(SEKME[anahtar]); } catch (e) { /* yoksay */ }
    }
    return;
  }
  const d = depoAl();
  if (d) {
    try { d.removeItem(anahtar); } catch (e) { /* yoksay */ }
  }
  delete bellek[anahtar];
}

export default { oku, yaz, sil, sirketeGecSekmesi };
